import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { routes as appRoutes } from "./routes";
import Layout from "./components/Layout";
import "./styles/globals.css";
import 'mapbox-gl/dist/mapbox-gl.css';
import { HelmetProvider } from 'react-helmet-async';
import { LogProvider } from "./contexts/LogContext";
import { TSGUserContextProvider } from "./contexts/TSGUserContext";
//import { useGoogleOneTapLogin } from "react-google-one-tap-login"
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";

function App() {

  // Disabled Google One Tap Login on 10/23/25 as it was causing issues with some users. They were authenticating successfully against an existing 
  // account of theirs, but there was no mapping in our system to link the Google account to their TSGUser account, so they were getting client errors.
  // useGoogleOneTapLogin({
  //   onSuccess: (response) => {
  //     console.log("Google One Tap Login Success", response);
  //   },
  //   onError: (error) => {
  //     console.log("Google One Tap Login Error", error);
  //   },
  //   googleAccountConfigs: {
  //     client_id: process.env.REACT_APP__GOOGLE_CLIENT_ID || "",
  //   }
  // });

  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <TSGUserContextProvider>
            <LogProvider>
              <Routes>
                {appRoutes.map((route) => (
                  <Route
                    key={route.key}
                    path={route.path}
                    element={<route.component />}
                  />
                ))}
              </Routes>
            </LogProvider>
          </TSGUserContextProvider>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
